import * as React from 'react';
import { observer } from 'mobx-react';
import {Elements} from 'react-stripe-elements';
import CheckoutForm from './CheckoutForm';
import languageStore from '../../lang';

@observer
export default class Checkout extends React.Component {
  render() {
    return (
      <Elements
        locale={languageStore.lang || 'auto'}
        options={{
          // Explicitne konfigurovať bez postal code
          fonts: [
            {
              cssSrc: 'https://fonts.googleapis.com/css?family=Open+Sans',
            },
          ],
        }}
      >
        <CheckoutForm
          {...this.props}
        />
      </Elements>
    );
  }
}


// WEBPACK FOOTER //
// ./src/App/Checkout/index.js